import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { BaseComponent } from './../base/base.component';

@Component({
  selector: 'app-tg-button',
  styleUrls: ['./tg-button.component.scss'],
  templateUrl: './tg-button.component.html'

})
export class TgButtonComponent extends BaseComponent implements OnInit {

  @Input() btnData: {
    icon: String,
    name: String
    type: String,
    btnLabel: String
  };

  isEditable = false;

  constructor(ele: ElementRef) {
    super(ele);
  }

  ngOnInit() {
    if (!this.btnData.type) {
      this.btnData.type = 'normal';
    }
  }

}

export class ButtonModel {
  icon: string;
  name: string;
}




// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/tg-button/tg-button.component.ts